import { ContextlessQueryObserverOptions, useSchemaQuery } from '@frontend/react-query-helpers';
import { SchemaIO } from '@frontend/schema';
import { SchemaSyncConfigV1Service, serviceName } from '../service';
import { ServiceQueries, ServiceStandardQueries, StandardQueryEndpointName } from '../types';

const DEFAULT_OPTIONS: ContextlessQueryObserverOptions = {
  refetchOnWindowFocus: false,
};

export type UseSyncConfigV1QueryArgs<
  EndpointName extends StandardQueryEndpointName,
  E = unknown,
  D = SchemaIO<ServiceQueries[EndpointName]>['output']
> = Omit<Parameters<typeof useSchemaQuery<ServiceStandardQueries, EndpointName, E, D>>[0], 'service' | 'serviceName'>;
/**
 * A wrapper around useSchemaQuery that uses the SyncConfigV1 service and serviceName.
 * This is intended to only be used internally in the `queries` directory of the library and not exported.
 */
export const useSyncConfigV1Query = <
  EndpointName extends StandardQueryEndpointName,
  E = unknown,
  D = SchemaIO<ServiceQueries[EndpointName]>['output']
>({
  options,
  ...args
}: UseSyncConfigV1QueryArgs<EndpointName, E, D>) =>
  useSchemaQuery<ServiceStandardQueries, EndpointName, E, D>({
    service: SchemaSyncConfigV1Service,
    serviceName,
    ...args,
    options: {
      ...DEFAULT_OPTIONS,
      ...options,
    },
  });

export type UseSyncConfigV1QueryEndpointArgs<
  EndpointName extends StandardQueryEndpointName,
  E = unknown,
  D = SchemaIO<ServiceStandardQueries[EndpointName]>['output']
> = Omit<UseSyncConfigV1QueryArgs<EndpointName, E, D>, 'endpointName'>;
